import React from 'react';
import styles from './CardDesignAndName.module.scss';
import plusCircled from '../../../../../../images/plus-circled.svg';

const CardDesignAndName = ({ title, setFiles, artWorkPreviewUrl, artWorkLoading }) => {
    return <>
        <div className={styles.packArtWork}>
            <h2 className={styles.packArtWorkTitle}>{title}</h2>

            {artWorkPreviewUrl ?
                <div className={styles.artWorkWrapper}>
                    <img className={styles.artWorkPreviewImage} src={artWorkPreviewUrl} alt='Artwork preview' />
                    <div className={styles.artWorkOverlay}>
                        {artWorkLoading ? (
                            <p>Loading...</p>
                        ) : (
                            <>
                                <input
                                    name='resources'
                                    className={styles.fileUpload}
                                    type='file'
                                    accept='image/*'
                                    onChange={(e) => setFiles(e.target.files)}
                                />
                                <img width='32' src={plusCircled} alt='plus-circle-svg' />
                            </>
                        )}
                    </div>
                </div> :
                <div className={`${styles.artWorkWrapper} ${styles.emptyArtWork}`}>
                    {artWorkLoading ? <p>Loading...</p> :
                        <>
                            <input
                                name='resources'
                                className={`${styles.fileUpload} basic-form__text-box`}
                                placeholder='Artwork'
                                type='file'
                                accept='image/*'
                                onChange={(e) => setFiles(e.target.files)}
                            />
                            <img width='48' src={plusCircled} alt='plus-circle-svg' />
                        </>
                    }
                </div>
            }

        </div>
    </>
}
export default CardDesignAndName;